import React from 'react'
import lottie from 'lottie-web'
import anim_1_auto from '../animations/1/auto.json'
import anim_1_loop from '../animations/1/loop.json'
import anim_2_auto from '../animations/2/auto.json'
import anim_2_loop from '../animations/2/loop.json'
import anim_3_auto from '../animations/3/auto.json'
import anim_3_loop_1 from '../animations/3/loop_1.json'
import anim_3_loop_2 from '../animations/3/loop_2.json'
import illu_4 from '../animations/4/data.json'
import illu_5 from '../animations/5/data.json'

if ( !window.requestAnimationFrame ) {

    window.requestAnimationFrame = ( function() {

        return window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function( /* function FrameRequestCallback */ callback, /* DOMElement Element */ element ) {

            window.setTimeout( callback, 1000 / 60 );

        };

    } )();

}

const blockAnimation = false
let topOffset = 0;

const animations = {
    'illu-1': [
        {data: anim_1_loop, autoplay: !blockAnimation, loop: true, style: {zIndex: 100, position: 'absolute', top: 120, left: 0, width: 560, height: 1043}},       
        {data: anim_1_auto, style: {zIndex: 110, position: 'absolute', top: 120, left: 0, width: 560, height: 1043}},
    ],
    'illu-2': [
        {data: anim_2_auto, style: {zIndex: 100, position: 'absolute', bottom: -570, left: 8, width: 975, height: 2064}},
        {data: anim_2_loop, autoplay: !blockAnimation, loop: true, style: {zIndex: 120, position: 'absolute', bottom: -570, left: 8, width: 975, height: 2064}},
    ],
    'illu-3': [       
        {data: anim_3_auto, style: {zIndex: 121, position: 'absolute', bottom: -613,     left: -201, width: 972, height: 1598}},
        {data: anim_3_loop_2, autoplay: !blockAnimation, loop: true, style: {zIndex: 130, position: 'absolute', bottom: -613,     left: -201, width: 972, height: 1598}},
        {data: anim_3_loop_1, autoplay: !blockAnimation, loop: true, style: {zIndex: 140, position: 'absolute', bottom: -613,     left: -201, width: 972, height: 1598}},        
    ],
    'illu-4': [{data: illu_4, style: {position: 'absolute', bottom: -590, left: -2, width: 1000, height: 1500}}],
    'illu-5': [{data: illu_5, style: {position: 'absolute', bottom: 0, left: -10, width: 1020, height: 1095}}]
}

function getScrollTop() {
    return document.body.scrollTop || document.documentElement.scrollTop;
}

let animationFlowIndex = -1;

function linearTransform(a, aMin, aMax, bMin, bMax) {
    return (a - aMin)/(aMax - aMin)*(bMax - bMin) + bMin;
}

const animationFlow = [
    { 
        name: 'illu-1',
        canActivate: (animation) => true,
        activate: (animation) => {
            animation[1].instance.play()
        }
    },
    { 
        name: 'illu-2',
        canActivate: (animation) => {
            const frame = linearTransform(window.innerWidth, 1280, 2560, 85, 68);
            return animations['illu-1'][1].instance && animations['illu-1'][1].instance.currentFrame > frame
        },
        activate: (animation) => {
            const frame = linearTransform(window.innerWidth, 1000, 2560, 68, 25.27);
            const svgElement = animation[0].instance.wrapper.childNodes[0];
            const defs = svgElement.childNodes[0];
            const mask = defs.childNodes[1];
            let transform = mask.childNodes[0].getAttribute("transform");
            if (transform) {
                const match = transform.match(/matrix\((.*)\)/);
                const parts = match[1].split(",");
                parts[parts.length-1] = "" + linearTransform(window.innerWidth, 1280, 2560, 888, 679);
                transform = "matrix(" + parts.join(",") + ")";
                mask.children[0].setAttribute("transform", transform);
            }
            
            animation[0].instance.playSegments([frame, 140], false);
        }
    },
    { 
        name: 'illu-2',
        canActivate: (animation) => {
            const anim = animations['illu-2'][1].instance
            return getScrollTop() > 1000 && anim && anim.firstFrame + anim.currentFrame > 140
        },
        activate: (animation) => {
            animation[0].instance.playSegments([140, 225], false);
        }
    },
    { 
        name: 'illu-3',
        canActivate: (animation) => {
            const anim = animations['illu-2'][0].instance
            if (!anim) return false
            const frameOffset = linearTransform(window.innerWidth, 1000.0, 2560.0, 205.5, 211.9);
            return anim.firstFrame + anim.currentFrame > frameOffset
        },
        activate: (animation) => {
            animation[0].instance.playSegments([30.5, 185], true);
        }
    },
    { 
        name: 'illu-4',
        canActivate: (animation) => {
            const anim = animations['illu-3'][0].instance
            return getScrollTop() > 1700 && anim.firstFrame + anim.currentFrame >= 180.0
        },
        activate: (animation) => {
            const frameOffset = linearTransform(window.innerWidth, 1000, 2560, 0, 4);
            animations['illu-3'][0].instance.playSegments([180+frameOffset, 250], true);
            animation[0].instance.playSegments([10, 500], true);
        }
    },
    { 
        name: 'illu-5',
        canActivate: () => {
            const anim = animations['illu-4'][0].instance
            const frameOffset = linearTransform(window.innerWidth, 1000.0, 2560.0, 230.9, 253.3);
            return anim.firstFrame + anim.currentFrame >= frameOffset
        },
        activate: (animation) => {
            animation[0].instance.goToAndPlay(276)
        }
    },
];

function checkAnimationFlow() {
    const nextAnimationFlowIndex = animationFlowIndex + 1;
    if (nextAnimationFlowIndex >= animationFlow.length) {
        return false;
    }

    const flow = animationFlow[nextAnimationFlowIndex]
    const animation = animations[flow.name]

    if (flow.canActivate && flow.canActivate(animation)) {
        animationFlowIndex++;
        flow.activate(animation)
    }

    requestAnimationFrame(checkAnimationFlow)
    return true;
}

function animationInit() {
    if (blockAnimation) {
        return
    }

    for(const animationName in animations) {
        const animation = animations[animationName]
        for (var i = 0; i < animation.length; i++) {
            if(!animation[i].instance)
                return
        }
    }

    requestAnimationFrame(checkAnimationFlow)
}


class LottieLayer extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.animation = lottie.loadAnimation({
            container: this.refs.container,
            renderer: 'svg',
            autoplay: this.props.autoplay,
            loop: this.props.loop,
            animationData: this.props.data,
            quality: 'high',
            name: this.props.name,
            renderSettings: {
                preserveAspectRatio: true
            }
        })

        this.props.onLoaded(this.animation)
    }

    componentWillUnmount() {
        this.animation.destroy()
        this.animation = null
        this.props.onUnloaded()
    }

    render() {
        return <div 
            ref="container" 
            className="animation-layer" 
            style={this.props.style} />
    }
}

class Lottie extends React.Component {
    constructor(props) {
        super(props)
        this.lottie = null
        const illuMatch = (props.settings.class || "").match(/illu-\d+/)
        this.animationName = illuMatch[0]
        this.layerAnimations = animations[this.animationName]
    }

    handleLayerLoaded(index, animation) {
        animations[this.animationName][index].instance = animation
    }

    handleLayerUnloaded(index) {
        animations[this.animationName][index].instance = null
    }

    componentDidMount() {
        animationInit()
    }
 

    render() {
        const props = this.props
        const classNames = ["animation"]
        if (props.settings.class) {
            classNames.push(props.settings.class)
        }

        return (
            <div  className={classNames.join(' ')}>
                {this.layerAnimations.map((l,i) => (
                    <LottieLayer 
                        key={i} 
                        onLoaded={(animation) => this.handleLayerLoaded(i, animation)}
                        onUnloaded={() => this.handleLayerUnloaded(i)}
                        data={l.data} 
                        style={l.style} 
                        autoplay={l.autoplay}
                        loop={l.loop}
                    />
                ))}
            </div>  
        )
    }
} 

export default Lottie


// WEBPACK FOOTER //
// ./src/components/Lottie.jsx